import { createSlice, Slice } from '@reduxjs/toolkit';

import { MandantReducersModel } from '../models/mandant-reducers.model';
import { MandantStateModel } from '../models/mandant-state.model';
import { getMandants } from '../thunks/get-mandants.thunk';

const initialState: MandantStateModel = {
  mandantsArr: null,
  activeMandantId: null,
};

export const mandantSlice: Slice<MandantStateModel, MandantReducersModel> =
  createSlice({
    name: 'mandants',
    initialState,
    reducers: {
      setActiveMandant(state, action) {
        state.activeMandantId = action.payload;
      },
    },
    extraReducers: builder => {
      builder.addCase(getMandants.fulfilled, function (state, action) {
        state.mandantsArr = action.payload;
      });
    },
  });

export const mandantSliceReducers = mandantSlice.reducer;

export const { setActiveMandant } = mandantSlice.actions;
